import React from 'react';
import ClassAssembly  from 'views/ClassAssembly12C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;